<template>
    <div class="container">
        <div class="container-main">
            <div class="main-handle">
                <el-button type="primary" size="mini" @click="goBackHandle">{{$t('goBack')}}</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column :label="$t('advertPaper')" align="center" width="140">
                    <template slot-scope="scope">
                        <div class="picture">
                            <el-image :src="scope.row.image + '_-100.png'" v-if="scope.row.image && (scope.row.image.includes('img.saonian.org') || scope.row.image.includes('img.joyingo.com'))">
                                <div slot="error"
                                     class="image-slot">
                                    <img src="../../assets/images/default.png"
                                         alt="">
                                </div>
                            </el-image>
                            <el-image :src="scope.row.image" lazy v-else>
                                <div slot="error" class="image-slot">
                                    <img src="../../assets/images/default.png" alt="">
                                </div>
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="showcaseName" :label="$t('advertBook')" align="center" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sort" :label="$t('sortValue')" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('whetherFinishCrop')" align="center" width="160">
                    <template slot-scope="scope">
                        <span v-if="scope.row.finish">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    class-name="handle"
                    :label="$t('handle')"
                    align="center"
                    width="240">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   size="mini"
                                   @click="finishHandle(scope.row.id)" v-if="!scope.row.finish" v-permission="['adve:paper-cropper']">{{$t('finish')}}</el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="previewHandle(scope.row)"
                                   v-if="scope.row.image">{{$t('preview')}}</el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="detailsHandle(scope.row)">{{$t('details')}}</el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="cropperHandle(scope.row)" v-permission="['adve:paper-cropper']">{{$t('slicing')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="currentPage"
                layout="sizes, prev, pager, next, total"
                :page-sizes="[10, 15, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <!-- 切图 -->
        <Cropper
            :parent-dialog="cropperDialog"
            @parent-update="getListData"
            @parent-close="cropperDialog = false"/>
        <!-- 预览 -->
        <Preview
            :parent-dialog="previewDialog"
            :parent-id="itemId"
            :parent-image="itemImage"
            @parent-close="previewDialog = false"/>
    </div>
</template>

<script>
import {searchAdvertBookList, queryAdvertPaperList, updateAdvertPaperState} from "@/api/modules/api";
import {mapMutations} from "vuex";
import Cropper from '@/components/advert/cropper/Add'
// 预览
import Preview from '@/components/advert/paper/Preview'
export default {
    name: "AdvertPaper",
    // 组件
    components: {
        Cropper,
        Preview
    },
    props: {},
    data() {
        return {
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
            itemId: '',
            itemImage: '',
            cropperDialog: false,
            previewDialog: false
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ...mapMutations('other', ['saveAdvertCropInfo']),
        // 获取数据列表
        getListData() {
            const params = {
                showcaseId: this.$route.query.id,
                page: this.currentPage,
                size: this.pageSize
            }
            queryAdvertPaperList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        
        // 裁减完成
        finishHandle (id) {
            this.$confirm(this.$t('finishCropHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                updateAdvertPaperState(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        
        // 详情
        detailsHandle (data) {
            this.saveAdvertCropInfo({
                bookId: data.showcaseId,
                paperId: data.id,
                image: data.image
            })
            this.$router.push({
                name: 'AdvertCropper',
                params: {
                    id: data.id
                }
            })
        },
        // 裁减
        cropperHandle (data) {
            this.saveAdvertCropInfo({
                bookId: data.showcaseId,
                paperId: data.id,
                image: data.image
            })
            this.cropperDialog = true
        },
    
        // 预览
        previewHandle (data) {
            this.itemId = data.id
            this.itemImage = data.image
            this.previewDialog = true
        },
    
        // 返回
        goBackHandle () {
            this.$router.go(-1)
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
    
    },
    activated () {
    
    },
    beforeRouteEnter(to, from, next) {
        next((vm)=>{
            if (to.name === 'AdvertPaper' && from.name !== 'AdvertCropper') {
                vm.currentPage = 1
                // 获取列表数据
                vm.getListData()
            } else if (to.name === 'AdvertPaper' && vm.tableData.length === 0){
                vm.currentPage = 1
                // 获取列表数据
                vm.getListData()
            }
        })
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
.main-handle{
    width: 100%;
    height: 60px;
    text-align: right;
}
</style>
